export const SET_MSHOP_BOTTOM_OVERRIDE = 'SET_MSHOP_BOTTOM_OVERRIDE';
export const ENABLE_MSHOP_BOTTOM_OVERRIDE = 'ENABLE_MSHOP_BOTTOM_OVERRIDE';
